import { render, staticRenderFns } from "./table-simulation.vue?vue&type=template&id=45705280&scoped=true"
import script from "./table-simulation.vue?vue&type=script&lang=js"
export * from "./table-simulation.vue?vue&type=script&lang=js"
import style0 from "./table-simulation.vue?vue&type=style&index=0&id=45705280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45705280",
  null
  
)

export default component.exports